<div
  [innerHTML]="sanitizedSvgContent$ | async"
  [style.width.px]="width"
  [style.height.px]="height ?? width"
  [attr.test-id]="testId"
  class="tw-m-0"
></div>
